import { AppBar, Box, Typography } from "@mui/material";
import React from "react";
import { Logo } from "@thekilroygroup/shared-ui";
import { Stack, useTheme } from "@mui/material";
import { LanguageSelector } from "../LanguageSelector/LanguageSelector";

interface IProps {
  children?: any;
}

export default function DesktopHeader(props: IProps) {
  const theme = useTheme();

  return (
    <AppBar
      position="sticky"
      elevation={1}
      sx={{
        backgroundColor: "white.main",
        color: "black.main",
        minHeight: 130,
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{
          height: 11.25 * 8,
          p: 3,
          position: "relative",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            height: "40px",
            left: 0,
            right: 0,
            top: "100%",
            backgroundColor: "primary.main",
          }}
        ></Box>
        <Logo height={20} color={theme.palette.black.main} />
        <Typography variant="h2" textTransform="uppercase">
          Flights
        </Typography>
        <LanguageSelector />
      </Stack>
      {props.children}
    </AppBar>
  );
}
